import { render } from "./AboutUs.vue?vue&type=template&id=263774ef&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "../assets/index.rem-AboutUs.css?vue&type=style&index=0&id=263774ef&scoped=true&lang=css"

import exportComponent from "E:\\virtual-weather-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263774ef"]])

export default __exports__